import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { getBaseCacheKey } from "@helpers/common";
import { useAppStore } from "./useAppStore";

const useCacheKey = () => {
	const {
		currentExamContext: { organizationId, projectId },
	} = useExamContext();

	const appId = useAppStore((state) => state.app?.id) || "";

	const { userLogicalId } = useAuthContext();

	if (!(organizationId && projectId && appId && userLogicalId)) {
		return {
			userCacheKey: "",
			baseCacheKey: "",
			reviewPromptCacheKey: "",
			consentCacheKey: "",
		};
	}

	const baseCacheKey = getBaseCacheKey({
		orgId: organizationId,
		projectId,
		appId,
	});

	const userCacheKey = `${baseCacheKey}:user-${userLogicalId}`;
	const reviewPromptCacheKey = `${baseCacheKey}:user-${userLogicalId}:review-prompt`;
	const tutorialCacheKey = `${baseCacheKey}:user-${userLogicalId}:tutorial`;
	const appContextCacheKey = `${baseCacheKey}:user-${userLogicalId}:app-context`;
	const consentCacheKey = `${baseCacheKey}:user-${userLogicalId}:consent`;

	return {
		userCacheKey,
		baseCacheKey,
		reviewPromptCacheKey,
		tutorialCacheKey,
		appContextCacheKey,
		consentCacheKey,
	};
};

export default useCacheKey;
